import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { LegalsResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const legals = {
    record(data: typeof Requests.Legals.Record.Input) {
        return post<typeof data, LegalsResponseTypes.Record>(`/legals/record`, data);
    },
    create(data: typeof Requests.Legals.Create.Input) {
        return post<typeof data>(`/legals/create`, data);
    },
    delete(id: string) {
        return postEmpty(`/legals/delete/${id}`);
    },
    obtain(id: string) {
        return get<LegalsResponseTypes.Obtain>(`/legals/obtain/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.Legals.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/legals/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
